export const mutations = {
  SET_INITIAL_BACKGROUND(state, recommendations) {
    state.initialBackgrounds = recommendations.map((el) => {
      el.title = el.text;
      el.background = `url(${el.urlImage})`;
      el.fontColor = '#ffffff';
      return el;
    });
  }
};

export const getters = {
  getInitialBackgrounds(state) {
    return state.initialBackgrounds;
  },
  getDiscoverLink: () => (params) => {
    let {
      link,
      linkSubscriptor,
      linkUrlBuilder,
      translateLink,
      localePath,
      urlBuilder,
      trailingSlash,
      isSubscriptor
    } = params;
    let actualLink = link;
    if (linkSubscriptor && isSubscriptor) {
      actualLink = linkSubscriptor;
      translateLink = true;
    } else if (linkUrlBuilder) {
      const { type, path, keyword, uid } = linkUrlBuilder;
      actualLink = urlBuilder(type, {
        path,
        keyword,
        uid
      });
    }
    return translateLink ? trailingSlash(localePath(actualLink)) : actualLink;
  }
};

export const actions = {
  async LOAD_INITIAL_BACKGROUND({ commit }) {
    try {
      const { data: response } = await this.$axios.get('recommendations/discover_main/');
      let recommendations = response.data;
      commit('SET_INITIAL_BACKGROUND', recommendations);
    } catch (error) {
      console.error('Discover | LOAD_INITIAL_BACKGROUND:', error);
    }
  }
};

export const state = () => ({
  initialBackgrounds: []
});
